
























import Vue from 'vue';
import ButtonFullscreen from '@/components/ButtonFullscreen.vue';
import ButtonExternal from '@/components/ButtonExternal.vue';
import MobileWarning from '@/components/MobileWarning.vue';
import Intro from '@/components/Intro.vue';
import Step1 from '@/components/Step1.vue';
import Step2 from '@/components/Step2.vue';
import Step3 from '@/components/Step3.vue';
import Step4 from '@/components/Step4.vue';
import Step5 from '@/components/Step5.vue';
import Step6 from '@/components/Step6.vue';
import Step7 from '@/components/Step7.vue';
import Step8 from '@/components/Step8.vue';

export default Vue.extend<any, any, any, any>({
	name: 'App',
	components: {
		ButtonExternal, ButtonFullscreen, MobileWarning, Intro, Step1, Step2, Step3, Step4, Step5, Step6, Step7, Step8,
	},
	data() {
		return {
			isTouchScreen: false,
			isFullscreen: false,
			currentAnchor: 'intro',
			sectionsHistory: {},
			options: {
				licenseKey: '9C66B3C4-E27D4419-8A271709-236B71E5',
				anchors: [
					'intro', 'step-1', 'step-2', 'step-3', 'step-4', 'step-5', 'step-6', 'step-7', 'step-8', 'outro',
				],
				navigation: true,
				afterLoad: (origin: object, destination: object, direction: string) => {
					// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
					// @ts-ignore
					this.currentAnchor = destination.anchor;
					this.sectionsHistory[this.currentAnchor] = true;
					this.sectionsHistory = { ...this.sectionsHistory };
				},
			},
		};
	},
	computed: {
		enableScroll() {
			return !this.isIframe || this.isFullscreen;
		},
		isSafariIframe() {
			return this.isSafari && this.isIframe;
		},
		isSafari() {
			return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		},
		isIframe() {
			return window.location.search === '?iframe';
		},
		visitedClassBuilder() {
			let classes = '';
			Object.keys(this.sectionsHistory).forEach((section: string) => classes = `${classes} visited-${section}`);
			return classes;
		},
	},
	mounted() {
		if ((('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))) {
			this.isTouchScreen = true;
		}

		this.$refs.fullpage.api.setAllowScrolling(false);
	},
});
